import type { SVGProps } from "react";
export interface CookieIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CookieIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CookieIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.186.905a11 11 0 0 1 1.684.003l.55.056.193.042c.434.136.752.525.786.992l.17 2.326.94.812.153.146c.288.304.48.686.552 1.099l.027.208.096 1.312.01.068c.04.15.17.263.329.278l.986.092.22.033c.438.087.837.31 1.14.637l.144.171.976 1.3 2.08.417.189.056c.424.165.714.577.714 1.046.006 5.78-4.456 10.666-10.31 11.096-6.128.45-11.46-4.153-11.91-10.28-.45-6.128 4.153-11.46 10.28-11.91Zm1.04 2.222a8.874 8.874 0 0 0-9.076 9.521 8.874 8.874 0 0 0 17.677.265l-1.173-.235a2.13 2.13 0 0 1-1.159-.658l-.124-.15-.973-1.297-.929-.085a2.626 2.626 0 0 1-2.348-2.185l-.028-.236L14 6.806l-.938-.812a2.13 2.13 0 0 1-.705-1.244l-.026-.209z"
      />
      <path
        fill={color}
        d="m12.01 16.875.115.006a1.124 1.124 0 0 1 0 2.238l-.116.006h-.008a1.125 1.125 0 0 1 0-2.25zm-4.306-3.171a1.125 1.125 0 0 1 1.59 1.59l-.998 1.001a1.125 1.125 0 0 1-1.59-1.59zm9.296.67.116.007a1.125 1.125 0 0 1 0 2.238l-.116.006h-1.5a1.125 1.125 0 0 1 0-2.25zm-3.99-3.499.116.006a1.125 1.125 0 0 1 0 2.239l-.116.005H13a1.126 1.126 0 0 1 0-2.25zm-6.5-1.5.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005H6.5a1.125 1.125 0 0 1 0-2.25zM8.874 8V6.5a1.125 1.125 0 0 1 2.25 0V8a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
